export const apiErrorHandling = (response) => {
	if (!response || typeof response.text !== 'function') {
		return Promise.resolve(
			response && response.message
				? response.message
				: 'En ukjent feil har skjedd'
		);
	}

	return response.text().then((errorMessage) => {
		try {
			const errorJson = JSON.parse(errorMessage);
			if (errorJson.error === 'TokenExpiredError') {
				localStorage.removeItem('authtoken-child');
				window.location.href = `/login`;
			}
			return errorJson;
		} catch (e) {}

		return errorMessage;
	});
};
